<div 
  class="container click" 
  [ngClass]="( activeIndex === index ? 'selecionado' : '' )"
  id="topbar-search-index-{{index}}" >

  <!-- <label class="informacao-extra">{{ index }} a: {{ activeIndex }}</label> -->
  <label class="paciente-nome">
    {{ paciente.nome }}
  </label>

  <label class="informacao-extra texto-cinza data-nascimento" *ngIf="dataNascimento">
    {{ dataNascimento }} - {{ idade }}
  </label>

  <label class="informacao-extra texto-cinza cpf" *ngIf="cpf">
    CPF: {{ cpf }}
  </label>
</div>